import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { LocationService } from '../../services/location.service';
import { ErrorService } from '../../../../core/services/error.service';
import { AddLocationDto } from '../../dtos/add-location.dto';
import { LocationFormFactory } from '../../mappers/location-form.factory';
import { AddLocationMapper } from '../../mappers/add-location.mapper';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-add-location',
  imports: [ReactiveFormsModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatCardModule, TranslocoPipe],
  templateUrl: './add-location.dialog.html',
  styleUrl: './add-location.dialog.scss'
})
export class AddLocationDialog implements OnInit {
  addLocationForm!: FormGroup;

  constructor(private dialogRef: MatDialogRef<AddLocationDialog>, private translocoService: TranslocoService,private locationService: LocationService, private errorService: ErrorService, private formBuilder: FormBuilder) {
  }

  ngOnInit(): void {
    this.addLocationForm = LocationFormFactory.createAddLocationForm(this.formBuilder);
  }

  close(): void {
    this.dialogRef.close(false);
  }

  addLocation(): void {
    if (this.addLocationForm.invalid) {
      this.addLocationForm.markAllAsTouched();
      return;
    }

    let addLocationDto: AddLocationDto = AddLocationMapper.toDto(this.addLocationForm.value);
    this.locationService.createLocation(addLocationDto).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
      error: (errorDto: HttpErrorResponse) => {
        this.errorService.handleError(errorDto, this.translocoService.translate("error.title.add_location"));
      }
    });
  }
}
